/** "☰ Filters": on phones the page's filter sidebar (.side) folds away under this bar, as old. */
export function SideToggle({ open, onToggle }: { open: boolean; onToggle: () => void }) {
  return (
    <button type="button" className="side-toggle" aria-expanded={open} onClick={onToggle}>
      <span>☰ Filters</span>
      <span className="side-x">{open ? '▲' : '▼'}</span>
    </button>
  );
}
